import React from 'react';
import './Divider.css';

/**
 * Baustein — Divider.
 * Horizontale Trennlinie, optional mit zentriertem Label (z.B. „oder").
 * Die Linien sitzen als ::before/::after links und rechts des Labels.
 *
 * Verwendung:
 *   <Divider>oder</Divider>      // Label-Trenner zwischen zwei Pfaden
 *   <Divider />                  // durchgehende Linie ohne Label
 *
 * Spacing ist Sache des Containers (Flex-Gap o.ä.) — der Divider bringt keine
 * eigene vertikale Margin mit, damit er in jedem Kontext (Formular, Liste,
 * Dialog) ohne Ausnahmeregeln passt.
 *
 * Props:
 *   children — optionales Label in der Mitte. Ohne Children → reine Linie.
 */
export default function Divider({ children }) {
  if (!children) return <hr className="divider divider--plain" />;
  return (
    <div className="divider">
      <span className="divider__label">{children}</span>
    </div>
  );
}
